import { styled } from '@mui/system';
import { IconButton } from '@mui/material';

export const StyledIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '6px',
  right: '6px',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  border: 'none',
  cursor: 'pointer',
  borderRadius: '50%',
  width: '35px !important',
  height: '35px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    transform: 'scale(1.1)',
  },

  '&:active': {
    transform: 'scale(0.95)',
  },
}));
